import React from 'react'
import Menu from '../component/Menu';
import { Helmet } from 'react-helmet';
import Getintouch2 from '../component/Getintouch2'
import FooterNew from '../component/FooterNew';
import ServicesHeader from '../component/ServicesHeader';
import Whoweserve from '../component/Whoweserve';
import ServiceDesc from '../component/ServiceDesc';
import AIInServices from '../component/AIInService';
import ServiceSection from '../component/ServiceSection';

import heroimage from '../images/Investment-advisory-bg.webp';


import service1heroImage from '../images/InvestmentAdvisory.webp';
import ser1cs from '../images/case-study-client41.webp';
import service2heroImage from '../images/TransactionAdvisory.webp';
import ser2cs from '../images/case-study-client50.webp';
import service3heroImage from '../images/ValuationAdvisory.webp';
import ser3cs from '../images/case-study-client13.webp';
// import service4heroImage from '../images/CorporateAdvisory.webp';
// import ser4cs from '../images/case-study-client40.webp';
import FaqServices from '../component/FaqServices';
import ServiceCS from '../component/ServiceCS';


import iacs1 from '../images/case-study-client44.webp';
import iacs2 from '../images/case-study-client42.webp';
import iacs3 from '../images/case-study-client41.webp';
// import TestimonialsCs from '../component/TestimonialsCs';


const herocontent = {
  "l1": "Insight driven",
  "l2": "Investment Advisory",
  "l3": "Sharper insights. Stronger investments. AI-enabled",
  "img": heroimage
};


const serviceDes = {
    description:
      "Helping clients identify opportunities, assess risk, and unlock value - powered by AI-embedded workflows and human expertise",

    stats: [
      {
        title: "50+",
        text: "Sectors Served",
      },
      {
        title: "$ 200 Bn",
        text: "AUM of Clients Served",
      },
      {
        title: "30%-35%",
        text: "AI enabled Due Diligence",
      },
    ],

    cta: {
      text: "VIEW OUR CASE STUDIES",
      href: "/case-studies",
    },
  };

const aiInvestmentData = {
    eyebrow: "ARTIFICIAL INTELLIGENCE",

    title: "AI in Investment Advisory",

    description:
      "AI is transforming every stage of the investment lifecycle - and for family offices, fund managers, and institutional investors, it is quickly becoming table stakes for maintaining an edge. We help you harness AI across sourcing, diligence, and portfolio monitoring, so your investment team spends less time processing information and more time forming conviction.",

    cards: [
      {
        icon: "fpa",
        title: "Sharper screening & diligence",
        description:
          "We deploy AI to accelerate target screening, market sizing, and data-room analysis - surfacing red flags, benchmarks, and value-creation levers earlier in the process, so you build conviction faster and with fewer blind spots.",
      },
      {
        icon: "reporting",
        title: "Faster deal execution",
        description:
          "From valuation models and feasibility studies to IC memos and deal collateral, we use AI to compress turnaround times on analytical heavy-lifting - helping you move at deal speed without compromising rigor.",
      },
      {
        icon: "risk",
        title: "Stronger portfolio oversight",
        description:
          "We build AI-enabled portfolio monitoring and reporting systems that consolidate performance data across your holdings, automate variance analysis, and flag emerging risks - giving you a real-time view of your entire portfolio, not a quarterly snapshot.",
      },
    ],

    bottom: [
      {
        title: "REAL OUTCOMES",
        description:
          "We've supported investors in applying AI across live mandates - from cutting screening timelines for a mid-market PE fund to automating portfolio reporting for a multi-asset family office. The outcome: more deals evaluated, faster conviction, and tighter oversight.",
        linkText: "Read the case study",
        href: "/knowledge#casestudies",
      },
      {
        title: "HOW WE HELP",
        description:
          "Our team plugs into your investment process as an offshore extension of your front and middle office - combining institutional-grade analysis with generative and agentic AI across screening, diligence support, valuation, and portfolio management.",
        linkText: "Talk to our team",
        href: "/contact#contactform",
      },
    ],
  };


const InvestmentAdvisory = {
  title: ["Investment Advisory"],

  accentColor: "#f21b70",
  bg:'#ffffff',
  subtitle:
    "We empower our clients to navigate the complexity of the financial landscape and provide insights on risk assessment, investment allocation and return optimization through a combination of sector expertise, rigorous analysis, & AI-enhanced research capabilities.",

  relevantFor: [
    "Private Equity / Venture Capital",
    "Hedge Funds",
    "Family Offices",
    "Asset Managers",
  ],

  heroImage:
    service1heroImage,

  services1: [
    {
      title: "Mergers & Acquisitions",
      description:
        "Leverage our insights, guidance and research support to identify potential targets, optimize value creation, mitigate risks and achieve synergistic outcomes.",
    },
    
    {
      title: "Pitch Decks & PPM",
      description:
        "Create impactful and compelling pitch decks that effectively communicate your business value proposition and make a compelling case for your business venture.",
    },
    {
      title: "Capital Raising",
      description:
        "Optimize your capital-raising efforts through our research support on identifying suitable funding sources and developing compelling investment propositions.",
    },
    {
      title: "Industry landscaping",
      description:
        "Gain insights into the market trends, competitive landscape and emerging opportunities to stay ahead of the curve in your industry.",
    },
    
  ],

  services2: [
    {
      title: "Portfolio Analysis & Monitoring",
      description:
        "Maintain a well-balanced portfolio that aligns with your financial goals, risk tolerance and time horizon through our research and analytics support on investment allocation, risk management and performance tracking.",
    },
  ],

  caseStudy: {
    label: "CASE STUDY",
    image:ser1cs,
    title:"Thematic Research & Acquisition Mapping",
    description:"Delivered a set of investment themes along with a detailed list of potential acquisition targets. The output enabled the client to refine its sourcing strategy and confidently initiate targeted outreach within the identified sub-sectors",
    buttonLabel: "→",
    href: "/knowledge/thematic-research-&-acquisition-mapping-for-a-family-office-with-diversified-investments",
  },
};

const InvestmentAdvisoryicons = {
  fpa: (
    <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.18182 25H17.7273C18.3788 25 18.9091 24.4742 18.9091 23.8281V17.9688C18.9091 17.9609 18.9051 17.9547 18.9044 17.9469C18.9485 17.9203 18.9921 17.893 19.0351 17.8648L25.3271 24.1039C25.3634 24.1413 25.4069 24.1711 25.4549 24.1916C25.5029 24.2122 25.5546 24.223 25.6069 24.2235C25.6592 24.224 25.7111 24.2142 25.7595 24.1947C25.808 24.1751 25.852 24.1461 25.889 24.1095C25.9261 24.0729 25.9554 24.0293 25.9753 23.9813C25.9951 23.9334 26.0052 23.882 26.0048 23.8301C26.0044 23.7782 25.9936 23.7269 25.9731 23.6793C25.9525 23.6316 25.9225 23.5884 25.885 23.5523L19.6505 17.3703C20.162 16.897 20.57 16.3244 20.8491 15.6882C21.1281 15.052 21.2723 14.3657 21.2727 13.6719C21.2715 12.8195 21.0539 11.9811 20.6401 11.234C20.2262 10.4869 19.6292 9.85508 18.9044 9.39688C18.9051 9.38906 18.9091 9.38281 18.9091 9.375V7.42188C18.9091 7.40859 18.9028 7.39766 18.902 7.38516C18.8999 7.36797 18.8965 7.35104 18.8918 7.33437C18.8791 7.2802 18.8549 7.22932 18.8208 7.18516C18.8153 7.17812 18.8161 7.16953 18.8106 7.1625L12.5076 0.13125L12.4997 0.126563C12.4515 0.0769049 12.3909 0.0407863 12.324 0.021875C12.3098 0.0177083 12.2951 0.0148438 12.2799 0.0132813C12.257 0.009375 12.2358 0 12.2121 0H1.18182C0.530242 0 0 0.525781 0 1.17188V23.8281C0 24.4742 0.530242 25 1.18182 25ZM20.4848 13.6719C20.4848 16.0414 18.5404 17.9688 16.1515 17.9688C13.7627 17.9688 11.8182 16.0414 11.8182 13.6719C11.8182 11.3023 13.7627 9.375 16.1515 9.375C18.5404 9.375 20.4848 11.3023 20.4848 13.6719ZM12.6061 1.41797L17.6382 7.03125H13C12.8267 7.03125 12.6061 6.70312 12.6061 6.44531V1.41797ZM0.787879 1.17188C0.787879 1.06827 0.829383 0.968918 0.903261 0.895661C0.977139 0.822405 1.07734 0.78125 1.18182 0.78125H11.8182V6.44531C11.8182 7.07734 12.3342 7.8125 13 7.8125H18.1212V8.98516C17.1696 8.59042 16.1196 8.49104 15.1098 8.70011C14.1 8.90918 13.1779 9.41689 12.465 10.1562H4.33333C4.22885 10.1562 4.12865 10.1974 4.05478 10.2707C3.9809 10.3439 3.93939 10.4433 3.93939 10.5469C3.93939 10.6505 3.9809 10.7498 4.05478 10.8231C4.12865 10.8963 4.22885 10.9375 4.33333 10.9375H11.8434C11.3867 11.6412 11.1143 12.4468 11.0508 13.2812H4.33333C4.22885 13.2812 4.12865 13.3224 4.05478 13.3957C3.9809 13.4689 3.93939 13.5683 3.93939 13.6719C3.93939 13.7755 3.9809 13.8748 4.05478 13.9481C4.12865 14.0213 4.22885 14.0625 4.33333 14.0625H11.05C11.1138 14.8969 11.3862 15.7024 11.8426 16.4062H4.33333C4.22885 16.4062 4.12865 16.4474 4.05478 16.5207C3.9809 16.5939 3.93939 16.6933 3.93939 16.7969C3.93939 16.9005 3.9809 16.9998 4.05478 17.0731C4.12865 17.1463 4.22885 17.1875 4.33333 17.1875H12.4091C12.4256 17.1875 12.4398 17.1805 12.4564 17.1781C13.1692 17.9202 14.0924 18.4303 15.1039 18.641C16.1154 18.8516 17.1675 18.7529 18.1212 18.3578V23.8281C18.1212 23.9317 18.0797 24.0311 18.0058 24.1043C17.9319 24.1776 17.8317 24.2188 17.7273 24.2188H1.18182C0.961212 24.2188 0.787879 24.0469 0.787879 23.8281V1.17188Z" fill="white"/>
    <path d="M4.33339 7.8125H9.06067C9.16515 7.8125 9.26535 7.77135 9.33922 7.69809C9.4131 7.62483 9.45461 7.52548 9.45461 7.42188C9.45461 7.31827 9.4131 7.21892 9.33922 7.14566C9.26535 7.0724 9.16515 7.03125 9.06067 7.03125H4.33339C4.22891 7.03125 4.12871 7.0724 4.05484 7.14566C3.98096 7.21892 3.93945 7.31827 3.93945 7.42188C3.93945 7.52548 3.98096 7.62483 4.05484 7.69809C4.12871 7.77135 4.22891 7.8125 4.33339 7.8125ZM4.33339 20.3125H14.5758C14.6803 20.3125 14.7805 20.2713 14.8544 20.1981C14.9283 20.1248 14.9698 20.0255 14.9698 19.9219C14.9698 19.8183 14.9283 19.7189 14.8544 19.6457C14.7805 19.5724 14.6803 19.5312 14.5758 19.5312H4.33339C4.22891 19.5312 4.12871 19.5724 4.05484 19.6457C3.98096 19.7189 3.93945 19.8183 3.93945 19.9219C3.93945 20.0255 3.98096 20.1248 4.05484 20.1981C4.12871 20.2713 4.22891 20.3125 4.33339 20.3125Z" fill="white"/>
    </svg>
  ),

  reporting: (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2033_5081)"><path d="M12.5664 0.316471C12.6657 0.216205 12.7838 0.13661 12.914 0.0822895C13.0443 0.0279689 13.1839 0 13.325 0C13.4661 0 13.6058 0.0279689 13.736 0.0822895C13.8662 0.13661 13.9844 0.216205 14.0837 0.316471L18.9312 5.21647C19.3407 5.62947 19.3512 6.29622 18.9539 6.72147L14.1064 11.919C14.0102 12.022 13.8946 12.105 13.7661 12.1631C13.6377 12.2212 13.499 12.2533 13.3581 12.2575C13.2172 12.2617 13.0769 12.238 12.9452 12.1877C12.8135 12.1374 12.6931 12.0616 12.5909 11.9645C12.3838 11.7668 12.2627 11.4956 12.2539 11.2094C12.245 10.9232 12.3491 10.645 12.5437 10.435L15.7812 6.96997H15.2737C14.0189 6.97697 12.5262 7.05047 11.4237 7.28497C8.68226 7.87379 6.22583 9.38525 4.46454 11.5669C2.70325 13.7487 1.74372 16.4685 1.74616 19.2725C1.74616 21.3375 2.25541 23.28 3.15666 24.995C3.21325 25.0968 3.24895 25.2089 3.26165 25.3246C3.27436 25.4404 3.26382 25.5576 3.23066 25.6692C3.1975 25.7809 3.14237 25.8848 3.06852 25.9749C2.99467 26.0649 2.90358 26.1394 2.80059 26.1938C2.6976 26.2482 2.58479 26.2815 2.46876 26.2917C2.35274 26.3019 2.23583 26.2889 2.12491 26.2534C2.01399 26.2178 1.91127 26.1605 1.8228 26.0848C1.73432 26.009 1.66186 25.9163 1.60966 25.8122C0.602542 23.9004 0.051637 21.7814 7.98274e-05 19.6212C-0.0514774 17.461 0.397713 15.3181 1.31248 13.3605C2.22724 11.4028 3.58275 9.68345 5.27286 8.33706C6.96297 6.99066 8.9418 6.05376 11.0544 5.59972C12.3407 5.32497 13.9769 5.25497 15.2544 5.24622L15.8844 5.24797L12.5594 1.88797C12.3586 1.68374 12.246 1.40877 12.246 1.12235C12.246 0.835918 12.3586 0.560956 12.5594 0.356721L12.5664 0.316471ZM26.7764 13.8247C27.5184 15.5502 27.9314 17.4472 27.9314 19.4247C27.9314 21.7172 27.3802 23.8697 26.4089 25.7772C26.2997 25.9768 26.1171 26.126 25.8998 26.1932C25.6825 26.2605 25.4475 26.2404 25.2447 26.1373C25.0419 26.0342 24.8872 25.8562 24.8135 25.641C24.7398 25.4257 24.7527 25.1903 24.8497 24.9845C25.7002 23.3167 26.1814 21.432 26.1814 19.437C26.1814 17.9495 25.9154 16.5145 25.4307 15.1845L26.7747 13.8387L26.7764 13.8247ZM23.4514 8.74972C23.7316 8.75372 23.9994 8.86598 24.1987 9.06297C24.3957 9.26226 24.5079 9.53003 24.5119 9.81022C24.5197 10.0911 24.4217 10.3647 24.2372 10.5767L23.7874 11.0702L15.7374 19.9602L15.2894 20.4555C15.1375 20.6258 14.9516 20.7622 14.7435 20.856C14.5355 20.9497 14.3101 20.9987 14.0819 20.9997C13.6033 20.9924 13.1469 20.7969 12.8114 20.4555C12.47 20.12 12.2745 19.6636 12.2672 19.185C12.2672 18.7195 12.4667 18.289 12.8114 17.9775L13.3067 17.5295L22.1967 9.47947L22.6902 9.02972C22.9012 8.84368 23.1755 8.74539 23.4567 8.75497L23.4514 8.74972Z" fill="white"/></g><defs><clipPath id="clip0_2033_5081"><rect width="28" height="28" fill="white"/></clipPath></defs></svg>
  ),

  risk: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.33333 28H7.2C6.35131 28 5.53737 27.6629 4.93726 27.0627C4.33714 26.4626 4 25.6487 4 24.8V22.6667M22.6667 28H24.8C25.6487 28 26.4626 27.6629 27.0627 27.0627C27.6629 26.4626 28 25.6487 28 24.8V22.6667M28 9.33333V7.2C28 6.35131 27.6629 5.53737 27.0627 4.93726C26.4626 4.33714 25.6487 4 24.8 4H22.6667M9.33333 4H7.2C6.77977 4 6.36365 4.08277 5.97541 4.24359C5.58717 4.4044 5.23441 4.64011 4.93726 4.93726C4.64011 5.23441 4.4044 5.58717 4.24359 5.97541C4.08277 6.36365 4 6.77977 4 7.2V9.33333M11.7413 9.03467L11.2387 11.0453C11.2269 11.092 11.2027 11.1346 11.1687 11.1687C11.1346 11.2027 11.092 11.2269 11.0453 11.2387L9.03467 11.7413C8.76533 11.808 8.76533 12.192 9.03467 12.2587L11.0453 12.7613C11.092 12.7731 11.1346 12.7973 11.1687 12.8313C11.2027 12.8654 11.2269 12.908 11.2387 12.9547L11.7413 14.9653C11.808 15.2347 12.192 15.2347 12.2587 14.9653L12.7613 12.9547C12.7731 12.908 12.7973 12.8654 12.8313 12.8313C12.8654 12.7973 12.908 12.7731 12.9547 12.7613L14.9653 12.2587C15.2347 12.192 15.2347 11.808 14.9653 11.7413L12.9547 11.2387C12.908 11.2269 12.8654 11.2027 12.8313 11.1687C12.7973 11.1346 12.7731 11.092 12.7613 11.0453L12.2587 9.03467C12.192 8.76533 11.808 8.76533 11.7413 9.03467ZM20 17.3333L19.4667 19.4667L17.3333 20L19.4667 20.5333L20 22.6667L20.5333 20.5333L22.6667 20L20.5333 19.4667L20 17.3333Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  ),
};

const TransactionAdvisory = {
  title: ["Transaction Advisory"],

  accentColor: "#f21b70",
  bg:'#EBEBEB',
  subtitle:
    "Supporting transactions from diligence through execution with structured analysis, valuation expertise, and data-driven insights that improve decision confidence and execution outcomes.",

  relevantFor: [
    "Private Equity / Venture Capital",
    "Corporates",
    "Investment Banks & Advisors",
    "Sovereign Wealth & Endowment Funds",
  ],

  heroImage:
    service2heroImage,

  services1: [
    {
      title: "Deal sourcing",
      description:
        "Identify potential investment targets and acquisition opportunities that align with your growth objectives.",
    },
    {
      title: "Due diligence support and deal structuring",
      description:
        "Evaluate opportunities, mitigate risks and optimize transaction outcomes through our guidance on optimizing terms, assessing valuation and negotiation strategies.",
    },
    {
      title: "Deal closing",
      description:
        "Close deals seamlessly through our assistance on preparation, negotiation and coordination on the complex financial and legal requirements of the deal.",
    },
    {
      title: "Deal execution",
      description:
        "Navigate the intricacies of deal implementation, including project management, coordination with stakeholders and monitoring of key milestones.",
    },
    
    
    
  ],

  services2: [
    {
      title: "Exit strategy planning",
      description:
        "Identify and execute optimal exit strategies, including divestment, IPOs and mergers through our support on valuation and transaction analysis.",
    },
  ],

  caseStudy: {
    label: "CASE STUDY",
    image:ser2cs,
    title:"Preliminary Due Diligence & Deal Model",
    description:"Delivered a comprehensive investment package including a robust deal model and strategic memo that enabled the client to evaluate the opportunity’s fit with their investment strategy. The analysis provided clarity on financial performance, market positioning & return potential, supporting a confident and informed investment decision.",
    buttonLabel: "→",
    href: "knowledge/preliminary-due-diligence-&-deal-model",
  },
};

const ValuationAdvisory = {
  title: ["Valuation Advisory"],

  accentColor: "#f21b70",
  bg:'#ffffff',
  subtitle:
    "Delivering independent valuation insights across businesses, funds, and asset classes through robust methodologies, market intelligence, and advanced analytical capabilities.",

  relevantFor: [
    "Real Estate",
    "Private Equity / Venture Capital",
    "Asset Managers",
    "Family Offices",
  ],

  heroImage:
    service3heroImage,

  services1: [
    {
      title: "Real Estate",
      description:
        "Optimize your real estate strategies and maximize the value of your land assets by making informed decisions regarding land acquisition, development and investments.",
    },
    {
      title: "Equity",
      description:
        "Enhance the value of your equity portfolio by making informed investment decisions with our support on financial modelling and market research.",
    },
    {
      title: "Alternative assets",
      description:
        "Maximize the value of your portfolio by accurately assessing the valuation of alternative asset classes through our advanced valuation techniques.",
    },
    {
      title: "Private companies",
      description:
        "Assess the correct value of your private business to take strategic growth and investment decisions.",
    },
    
    
    
  ],

  services2: [
    {
      title: "Private equity fund",
      description:
        "Drive successful investment outcomes by accurately and comprehensively assessing the value of private equity funds.",
    },
  ],

  caseStudy: {
    label: "CASE STUDY",
    image:ser3cs,
    title:"Equity Valuation & Fairness Opinion Exercise",
    description:"Our multi-prong valuation analysis equipped the client to identify optimal entry and exit points, navigate market dynamics, and optimize their portfolio for maximized returns.",
    buttonLabel: "→",
    href: "/knowledge/equity-valuation-&-fairness-opinion-exercise-for-a-u.s.based-hedge-fund",
  },
};

// // const CorporateAdvisory = {
// //   title: ["Corporate Advisory"],

// //   accentColor: "#f21b70",
// //   bg:'#EBEBEB',
// //   subtitle:
// //     "With a deep understanding of the industry dynamics and a data-driven approach, we work closely with our clients to develop strategies, optimize operations, identify growth opportunities and enhance shareholder value",

// //   relevantFor: [
// //     "Corporates & Growth-Stage Businesses",
// //     "Family Offices",
// //     "Asset Managers",
// //   ],

// //   heroImage:
// //     service4heroImage,

// //   services1: [
// //     {
// //       title: "Strategy and development",
// //       description:
// //         "Define your business direction, identify growth opportunities, implement actionable plans and drive organizational transformation through research-led insights and strategies",
// //     },
    
// //     {
// //       title: "Financial planning and analysis",
// //       description:
// //         "Optimize financial performance and strengthen budgeting, forecasting and reporting processes to drive sustainable business growth",
// //     },
// //     {
// //       title: "Investment and finance",
// //       description:
// //         "Develop robust investment strategies, optimize capital allocation and achieve your organization's financial objective through comprehensive solutions that maximize returns and mitigate risks",
// //     },
// //     {
// //       title: "Budget analysis",
// //       description:
// //         "Enhance financial control and performance management by effectively allocating resources, identifying cost-saving opportunities and tracking performance",
// //     },
// //   ],

// //   services2: [
    
// //   ],

// //   caseStudy: {
// //     label: "CASE STUDY",
// //     image:ser4cs,
// //     title:"Fundraising support Portfolio-level Retention Analysis for a technology-focused PE firm",
// //     buttonLabel: "→",
// //     href: "#case-study",
// //   },
// };

// const testimonialsdata = [
//   {
//     "id": 1,
//     "quote": "[Placeholder] PS turned fragility into resilience. A migration that stalled for months was executed flawlessly in weeks. Their team combined deep technical expertise with a pragmatic, no-drama approach that inspired confidence at every step. What once felt like a never-ending roadblock became a smooth transition, completed faster than we imagined possible. Beyond just delivery, they left us with stronger systems, clearer processes, and a renewed belief in what our technology could achieve.",
//     "name": "Jane Doe",
//     "role": "Marketing lead",
//     "company": "ABC private limited",
//     "image": "/images/testimonials/jane-doe.jpg"
//   },
//   {
//     "id": 2,
//     "quote": "[Placeholder] What impressed us most wasn't just the speed, but the way they anticipated challenges and solved them before they became problems. The team was transparent, dependable, and deeply invested in our success. Today, our systems are more stable and scalable than ever - and we owe that transformation to PS.",
//     "name": "Peter Parker",
//     "role": "Wed developer",
//     "company": "Queens United",
//     "image": "/images/testimonials/peter-parker.jpg"
//   },
//   {
//     "id": 3,
//     "quote": "[Placeholder] Their team transformed a stalled project into a smooth, predictable delivery. They brought clarity to complex technical challenges and made every stage of the process feel effortless.",
//     "name": "Sarah Wilson",
//     "role": "Product manager",
//     "company": "Tech Solutions",
//     "image": "/images/testimonials/sarah-wilson.jpg"
//   },
//   {
//     "id": 4,
//     "quote": "[Placeholder] From the first conversation to final delivery, the team demonstrated excellent technical knowledge, communication, and ownership. The result exceeded our expectations.",
//     "name": "Michael Scott",
//     "role": "CEO",
//     "company": "Dunder Mifflin",
//     "image": "/images/testimonials/michael-scott.jpg"
//   }
// ]

 const faqData = {
    title: "What Leaders Want To Know",

    defaultOpen: 0,

    items: [
      {
        question:
          "What problems do clients bring to Preferred Square's investment advisory team?",

        answer:
          "Clients typically arrive when analytical capacity becomes the binding constraint on investment decisions — capital is available and direction is set, but the work can't be produced at the pace the market demands. Common triggers include no repeatable approach to key decisions, compressed deadlines on consequential work like a model or IC paper, and weak portfolio reporting. Most firms try solving this internally first: analysts get stretched thin, institutional knowledge concentrates in one or two people, and internal teams often lack the methodological depth an external advisory firm brings.",
      },

      {
        question:
          "What does an investment advisory engagement produce, and what do clients keep afterward?",

        answer:
          "Five outputs account for most of the work: financial models, real estate valuation and feasibility reports, investment research, deal collateral, and portfolio analytics and monitoring — each built for a named stakeholder and decision. Work commissioned as a one-off frequently becomes business-as-usual: ongoing portfolio monitoring, recurring research refreshes, and automated dashboards are the elements most often retained beyond the original brief. Clients also draw on strategic observations that fall outside the original scope, which Preferred Square treats as part of the mandate rather than a separate engagement.",
      },

      {
        question:
          "Which clients, sectors, and geographies does Preferred Square work with?",

        answer:
          "Clients span private equity and venture capital funds, family offices, asset managers, real estate developers and owners, investment banks, and corporates. Real estate, valuation, and feasibility mandates concentrate in Saudi Arabia and the wider Gulf; financial modelling and investment research for funds concentrate in the US and Europe alongside the Gulf. Real estate and private equity carry the deepest repeat experience, with valuation advisory the most developed point of view — the discipline where an unreliable number is costliest, since it's defended to an investment committee or auditor.",
      },

      {
        question:
          "Why choose Preferred Square over a large advisory firm, a freelancer, or an in-house hire?",

        answer:
          "Clients choose Preferred Square for senior attention and certified process at materially lower cost than a large advisory firm, with more reliability than a freelancer and none of a permanent hire's fixed commitment. Against freelancers specifically: ISO- and SOC 2-certified security, team depth instead of one person, and continuity through personnel change. That continuity carries extra weight in investment advisory — a permanent hire concentrates institutional knowledge in one person, while a stable external team distributes it across the group.",
      },
      {
        question:
          "Who will be working on our engagement?",

        answer:
          "Every engagement is staffed by a multi-tier team — analyst, consultant, and a Senior Consultant acting as Engagement Lead — rather than a single resource. Analysts handle modelling, research, and data work directly with the client; consultants own analytical structure; the Senior Consultant is accountable for the mandate. Teams are assigned by role, not named individual, so no single person is a point of failure — the historical context behind a model or data set stays with the team even when personnel change on either side.",
      },
      {
        question:
          "How is impact measured, and how do clients describe working with Preferred Square?",

        answer:
          "Clients consistently describe Preferred Square as an extension of their team rather than a transactional vendor — one that understands financial services workflows and releases capacity so decisions are better informed. That's a deliberately higher bar than “delivered a document”: it's measured on the quality of the decision the document supported, which is why scope tends to widen after a first mandate. Preferred Square runs a structured feedback programme, and 96% of clients say they'd refer the firm, most often citing analysis quality, responsiveness, and openness to feedback.",
      },

      {
        question:
          "How are engagements structured, and how quickly do they start?",

        answer:
          "Engagements run in four structures: fixed-scope (a defined valuation, model, or research piece), dedicated team (capacity that scales with the mandate), retained advisory (recurring portfolio monitoring or reporting), and block-of-hours (flexible, drawn down as needed, without a dedicated team). A multi-tier team is assigned from day one; week one includes a kickoff call, knowledge transfer, and scoping workshops, with the first tangible output reaching clients within two to five days. On live transactions, turnaround follows the deal timetable.",
      },

      {
        question:
          "Is Preferred Square ISO and SOC 2 compliant?",

        answer:
          "Yes — controls cover data confidentiality, integrity, and access management across every engagement. These questions come most often from institutional investors and global corporates, concerned with deal and portfolio data confidentiality, regulatory compliance, and operational risk in an offshore model — concerns that carry extra weight here, since the material handled is frequently pre-transaction and price-sensitive. NDAs and data processing agreements are executed before any data is shared. Certification means these questions are answered with audit evidence, not assurance.",
      },

      {
        question:
          "Do investment advisory engagements expand beyond the original scope?",

        answer:
          "Frequently, along a consistent path — a single deliverable, then ongoing support, then adjacent service lines. A US private equity firm with roughly $4.5 billion in assets under management engaged Preferred Square for one resource on transaction due diligence and financial modelling; as deal activity grew, that became a multi-person team covering portfolio company valuations, Power BI fund dashboards, and strategy support. The client has since partnered on AI-enabled workflows for due diligence and reporting — the relationship now spans transactions, valuations, analytics, and process improvement.",
      },
    ],
  };
  
const  caseStudies =  {
  "sectionTitle": "Case Studies",
  "items": [
    {
      "id": 1,
      "image": iacs1,
      "title": "Fund Raising Support Portfolio-Level Investment Analysis",
      "description": "A Software-as-a-Service (SaaS) focused operator of tech companies growing tech ecosystem by investing across high potential technology and software businesses",
      "link": "/knowledge/fundraising-support-portfolio-level-retention-analysis-for-a-technology-focused-pe-firm"
    },
    {
      "id": 2,
      "image": iacs2,
      "title": "Subsequent Closing Deck for a Multi-Strategy Private Equity Fund",
      "description": "A multi-strategy mid-market private equity fund focused on investing in growing companies within fragmented industries",
      "link": "/knowledge/subsequent-closing-deck-for-a-multi-strategy-private-equity-fund"
    },
    {
      "id": 3,
      "image": iacs3,
      "title": "Thematic Reserach & Acquisition Planning",
      "description": "A prominent family office focusing on venture, growth and buyout investments across diverse sectors",
      "link": "/knowledge/thematic-research-&-acquisition-mapping-for-a-family-office-with-diversified-investments"
    }
  ]
}


const InvestmentAdvisoryService = ({setBlank}) => {
  return (
     <>
        <Helmet>
            <title>Investment Advisory</title>
             <meta property="og:title" content="Investment Advisory" />
             <meta name='og:description' content='Investment Advisory' />
             <meta name='keywords' content='' />
        </Helmet>
        <Menu setBlank={setBlank} />
        <ServicesHeader herocontent={herocontent} />
        <ServiceDesc serviceDes={serviceDes} />
        <AIInServices data={aiInvestmentData} icons={InvestmentAdvisoryicons} setBlank={setBlank} />
        <ServiceSection data={InvestmentAdvisory} />
        <ServiceSection data={TransactionAdvisory} />
        <ServiceSection data={ValuationAdvisory} />
        {/* <ServiceSection data={CorporateAdvisory} /> */}
        {/* <TestimonialsCs testimonials = {testimonialsdata} /> */}
        <Whoweserve />
        <Getintouch2 setBlank={setBlank} />
        <ServiceCS caseStudies={caseStudies} />
        <FaqServices data={faqData} />
        <FooterNew setBlank={setBlank} />
     </>
  )
}

export default InvestmentAdvisoryService



